export default __webpack_public_path__ + "static/Sohne-Halbfett-f50be91b3697ccf4cb2fc6be828963fe.woff2";